import {useMutation} from '@github-ui/react-query'
import {deleteUserContentEditMutation as deleteUserContentEditMutationQueryId} from '@github-ui/server-persisted-queries'
import type {DeleteUserContentEditMutationMutation} from '@github-ui/server-persisted-queries/types/deleteUserContentEditMutation'
import {reactFetchJSON} from '@github-ui/verified-fetch'

type GraphQLResponse = {
  data?: DeleteUserContentEditMutationMutation | null
  errors?: ReadonlyArray<{message?: string}> | null
}

export async function deleteUserContentEditRequest(id: string): Promise<DeleteUserContentEditMutationMutation> {
  const response = await reactFetchJSON(
    `/user_content_edits/${encodeURIComponent(id)}.json?queryId=${deleteUserContentEditMutationQueryId}`,
    {method: 'DELETE'},
  )
  const result = (await response.json()) as GraphQLResponse
  const error = result.errors?.find(item => item.message)?.message
  if (!response.ok || error || !result.data?.deleteUserContentEdit?.userContentEdit) {
    throw new Error(error ?? 'Failed to delete user content edit')
  }
  return result.data
}

export function useDeleteUserContentEditMutation() {
  return useMutation({
    mutationFn: deleteUserContentEditRequest,
  })
}
